module.exports = __webpack_public_path__ + "img/ai_qa_icon.f3e60f93.png";